import { Component, Input, OnInit, ViewChild, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, forwardRef } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";

import { IDropdownHieararchy, IDropdownHieararchyItem } from "../../../interfaces/idropdownconfig";
import { IDropDownView, IDropDownItemView } from "../../../interfaces/idropdowns";
import { DropDownItem } from "../../../models/dropdown";
import { NgSelectComponent } from "../../shared/ng-select/ng-select.component";

@Component({
    selector: "dropdownhierarchyitem",
    templateUrl: "./dropdownhierarchyitem.component.html",
    standalone: true,
    imports: [CommonModule, FormsModule, BsDropdownModule, NgSelectComponent, forwardRef(() => DropdownHierarchyItemComponent)],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})

export class DropdownHierarchyItemComponent implements OnInit {
    @Input() dropDownHieararchy: IDropdownHieararchy;
    @Input() parentDropDownItem: IDropdownHieararchyItem;
    @Input() availableDropDowns: IDropDownView[];
    @ViewChild("childDropdownComponent") childComponent: DropdownHierarchyItemComponent;
    @ViewChild("ngSelectComponent") ngSelectComponent: any;
    selectedItem: DropDownItem;
    dropdownItems: DropDownItem[] = new Array();
    selectedDropDownItem: IDropdownHieararchyItem;
    dropDown: IDropDownView;

    ngOnInit(): void {
        this.setDropDown();
    }

    setDropDown(): void {
        if (!this.dropDownHieararchy.dropDownId) {
            this.resetSelectedItem();
            return;
        }

        this.dropdownItems = new Array();
        this.dropDown = this.availableDropDowns.filter((i: IDropDownView) => { return i.id === this.dropDownHieararchy.dropDownId; })[0];
        this.dropDown.items.forEach((d: IDropDownItemView) => {
            this.dropdownItems.push({ id: d.id, text: d.text, code: d.code });
        });
        if (!this.selectedItem || !this.dropdownItems.find((i: DropDownItem) => i.id === this.selectedItem.id)) {
            this.resetSelectedItem();
        }
    }

    resetSelectedItem(): void {
        // Reset current selection with explicit null values
        this.selectedItem = { id: null, text: "", code: null };
        this.selectedDropDownItem = null;
        
        // Force ng-select component to reset its display
        setTimeout(() => {
            if (this.ngSelectComponent) {
                this.ngSelectComponent.writeValue(null);
                this.ngSelectComponent.activeValue = '';
                this.ngSelectComponent.displayValue = '';
                this.ngSelectComponent.searchTerm = '';
                this.ngSelectComponent.updateFilteredItems();
            }
        }, 0);
        
        // Reset child component if it exists without destroying its structure
        setTimeout(() => {
            if (this.childComponent) {
                this.childComponent.resetSelectedItem();
            }
        }, 50);
    }

    onDropDownItemSelected(selectedItem: DropDownItem): void {
        this.selectedItem = selectedItem;
        let dropDownHierarchyItem: IDropdownHieararchyItem[] = this.dropDownHieararchy.items.filter((i: IDropdownHieararchyItem) => { return i.id === selectedItem.id; });
        if (dropDownHierarchyItem.length > 0) {
            this.selectedDropDownItem = dropDownHierarchyItem[0];
        } else {
            this.selectedDropDownItem = null;
        }
        
        // Force reset child component after parent selection changes
        setTimeout(() => {
            if (this.childComponent) {
                this.childComponent.resetSelectedItem();
                this.childComponent.setDropDown();
            }
        }, 0);
    }

    resetChildDropdown(parentItem: IDropdownHieararchyItem): void {
        if (parentItem && parentItem.childDropDown) {
            // Reset all child items recursively
            if (parentItem.childDropDown.items) {
                parentItem.childDropDown.items.forEach((item: IDropdownHieararchyItem) => {
                    if (item.childDropDown) {
                        this.resetChildDropdown(item);
                    }
                });
            }
            // Clear the child dropdown
            parentItem.childDropDown = null;
        }
    }

    getActiveSelection(): DropDownItem[] {
        // Return empty array if no valid selection
        if (!this.selectedItem || !this.selectedItem.id) {
            return [];
        }
        return [this.selectedItem];
    }

    getDropDownById(id: number): IDropDownView {
        return this.availableDropDowns.filter((d: IDropDownView) => { return d.id === id; })[0];
    }

    ngOnChanges(): void {
        this.setDropDown();
        if (this.parentDropDownItem) {
            // Reset when parent changes
            setTimeout(() => {
                this.resetSelectedItem();
            }, 0);
        }
    }

    onRemoveClicked(): void {
        if (this.parentDropDownItem) {
            // this is the root dropdown
            this.parentDropDownItem.childDropDown = null;
            this.resetSelectedItem();
        } else {
            this.dropDownHieararchy.dropDownId = null;
            this.dropDownHieararchy.id = null;
            this.dropDownHieararchy.items.forEach((i: IDropdownHieararchyItem) => { i.childDropDown = null; });
            this.resetSelectedItem();
            this.dropDown = null;
        }
    }

    onAvaliableDropdownSelected(availableDropDown: IDropDownView): void {
        let dropdownHiearachy: IDropdownHieararchy;
        if (!this.dropDownHieararchy.dropDownId) {
            // this is the root dropdown
            dropdownHiearachy = this.dropDownHieararchy;
            this.dropDownHieararchy.dropDownId = availableDropDown.id;
        } else {
            dropdownHiearachy = <IDropdownHieararchy>{ id: null, dropDownId: availableDropDown.id, items: [] };
            this.selectedDropDownItem.childDropDown = dropdownHiearachy;
        }
        availableDropDown.items.forEach((i: IDropDownItemView) => {
            dropdownHiearachy.items.push(<IDropdownHieararchyItem>{ id: i.id, childDropDown: null});
        });
        this.setDropDown();
    }
}
